import React, { useState, useContext, useEffect } from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { AiOutlineEdit } from 'react-icons/ai';
import { ModalCtx } from '../../../contexts';


const Select = ( { label, db, value, options } ) => {
    const { setDraftValues } = useContext( ModalCtx );
    const [ v, setV ] = useState( value );
    const [ plist, setPicklist ] = useState( [] );

    useEffect( () => {
        if ( options && options[db] ) {
            setPicklist( [ ...options[db] ] );
        } else {
            console.log( 'unable to set plist for: ' + db );
        }
    }, [ options, db ] );

    const handleDraft = ( e ) => {
        setV( e.target.value );
        setDraftValues( prevState => (
            {
                ...prevState,
                [e.target.id]: e.target.value
            }
        ) );
    }

    return (
        <Col>
            <Form.Group as={Row} className='tf-form-group align-items-center' controlId={db}>
                <Form.Label column xs='auto' className='col-md-auto p-0 fw-light'>{label}</Form.Label>
                <Col xs='auto' className='tf-form-select-field me-1'>
                    <Form.Select size='sm' className='tf-modal-select-input' value={v} onChange={handleDraft}>
                        {
                            plist.map( ( p, idx ) => <option key={idx} value={p.value} selected={ p.value === value }>{p.label}</option>)
                        }
                    </Form.Select>
                </Col>
                {/* <Col className='tf-form-edit-icon' xs='auto'><AiOutlineEdit /></Col> */}
            </Form.Group>
        </Col>
    )
}

export default Select;